import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect, useDispatch, useSelector } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { logoutAdminUser } from "store/admin/Authentication/login/actions"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { bsh_getBothPrevAndCurrentAdminUserDetails, bsh_setPrevToCurrentAdminUserDetails } from "helpers/sf_browser_storage_helper"

const ProfileMenu = props => {
    // Declare a new state variable, which we'll call "menu"

    const [user, setUser] = useState()
    const [menu, setMenu] = useState(false)

    const { current_user } = useSelector(state => ({
        current_user: state.LoginAdminUser.current_user
    }));

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        setUser(current_user)
    }, [current_user])

    const onClickLogout = () => {
        dispatch(logoutAdminUser(history))
    }

    const activeAuthToken =  bsh_getBothPrevAndCurrentAdminUserDetails();

    const adminAccessLogout = () => {
        bsh_setPrevToCurrentAdminUserDetails(activeAuthToken);
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    }

    return (
        <React.Fragment>
            <Dropdown
            isOpen={menu}
            toggle={() => setMenu(!menu)}
            className="d-inline-block"
            >
                <DropdownToggle className="btn header-item" tag="button" id="page-header-user-dropdown">
                        <span className="d-none d-lg-inline-block ms-2 me-1 text-black">{user?.email}</span>
                        <i className="mdi mdi-chevron-down d-none text-black d-xl-inline-block" />
                        <i className="bx bx-user d-lg-none d-inline-block" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    {
                        (activeAuthToken.current_token && activeAuthToken.prev_token) ?
                            (<Link to="/#" onClick={adminAccessLogout} className="dropdown-item">
                                <i className="bx bx-undo font-size-16 align-middle me-1 text-danger" />
                                <span>{props.t("Return to Original Account")}</span>
                            </Link>) : (
                                <Link to="#" onClick={onClickLogout} className="dropdown-item">
                                    <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
                                    <span>{props.t("Logout")}</span>
                                </Link>)
                    }

                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

ProfileMenu.propTypes = {
    success: PropTypes.any,
    t: PropTypes.any,
}

const mapStatetoProps = state => {
    const { error, success } = state.Profile
    return { error, success }
}

export default withRouter(
    connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
